export { default } from './SpeakersGridSection';
export type { SpeakersSectionRawProps } from '../SpeakersSection';
